export interface Category {
  name: string;
  url: string;
}

export const categories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export const testimonials = [
  {
    name: 'Sarah Mitchell',
    role: 'Fashion Enthusiast',
    headline: 'Completely changed how I shop online',
    content: 'The Superbuy Spreadsheet saved me hours of scrolling through countless websites. Everything is organized by category and updated regularly. I have found pieces I would have never discovered on my own. Highly recommend for anyone serious about fashion shopping.',
  },
  {
    name: 'David Chen',
    role: 'Streetwear Collector',
    headline: 'Best resource for finding rare pieces',
    content: 'As a collector, finding authentic streetwear is challenging. The Superbuy Spreadsheet connects me directly to what I need without the noise. The categories are well-organized and the links are always current.',
  },
  {
    name: 'Emily Roberts',
    role: 'Personal Stylist',
    headline: 'My go-to research tool for clients',
    content: 'I use the Superbuy Spreadsheet daily to source options for my styling clients. The breadth of categories from shoes to accessories makes it a one-stop resource. My workflow has become significantly more efficient.',
  },
  {
    name: 'Marcus Johnson',
    role: 'Budget Shopper',
    headline: 'Helps me find the best value',
    content: 'Before discovering this resource, I would spend days comparing products across different sites. Now the Superbuy Spreadsheet does the hard work of organization so I can focus on finding the best deals that match my style.',
  },
  {
    name: 'Olivia Park',
    role: 'Fashion Blogger',
    headline: 'Essential for content research',
    content: 'Every fashion blogger needs reliable sources for product research. The Superbuy Spreadsheet is consistently updated and the categorization makes it incredibly easy to navigate. It has become an indispensable part of my research toolkit.',
  },
  {
    name: 'James Wilson',
    role: 'Online Shopping Newcomer',
    headline: 'Made online shopping less overwhelming',
    content: 'I was completely lost when I first started shopping online for fashion. The Superbuy Spreadsheet gave me a clear starting point and helped me understand how to navigate different categories. The beginner-friendly organization is exactly what newcomers need.',
  },
];